import axios from 'axios';

import * as utils from '../utils/utils.js';

export const fetchParticipant = async (participant_id, currentParticipantCheck = false) => {
    var session_url =
        utils.backendUrl() + `/participant/?participant_id=${participant_id}`;
    try {
        const response = await axios.get(session_url, {
            headers: {
                'Content-Type': 'application/json',
            },
        });
        return response.data.participant;
    } catch (err) {
        // The values stored in the currentParticipantId map in localhost can include invalid values,
        // for example if the participant is deleted after the id has been saved to the map. In such
        // scenarios we expect 404 errors, which need to be handled gracefully.
        if (!currentParticipantCheck || err.response.status !== 404) {
            // Hmm, wonder if these can simply be deleted?
            console.log(err.message);
            console.log(err.response);
        }
        throw err;
    }
};
